import { Type2LongString, Type2LongStringType } from "./Type2LongString";
import { Component, Input, OnInit, Optional } from "@angular/core";
import { PagingTableComponent, TabComponent, ModalTabComponent } from "@xo/client-common";

@Component({
    selector: "spec-app-type2-long-string-table",
    styleUrls: ["./type2LongString.table.scss"],
    templateUrl: "./type2LongString.table.html"
})
export class Type2LongStringTable extends PagingTableComponent<Type2LongString> implements OnInit {

    @Input() title: string;

    Type2LongString = Type2LongString;


    valueListFieldSelectValues = [];

    valueListArraySelectValues = [];

    constructor(
        @Optional() modalTab: ModalTabComponent, @Optional() tab: TabComponent) {
        super(Type2LongStringType, Type2LongString.columnInfo, modalTab || tab);
        this.valueListFieldSelectValues = this.createReferenceMap(Type2LongString.valueListFieldKeys, Type2LongString.getValueListFieldValues);
        this.valueListArraySelectValues = this.createReferenceMap(Type2LongString.valueListArrayKeys, Type2LongString.getValueListArrayValues);
    }

    async ngOnInit() {
        this.refreshList();
    }

    getClasses(type2LongString) {
        let classes: any = { objects: true };
        return classes;
    }

    formatValueListField(valueListField) {
        return Type2LongString.getValueListFieldValues(valueListField);
    }

    formatValueListArray(valueListArray) {
        if (!valueListArray) {
            return "";
        }
        return valueListArray.map(Type2LongString.getValueListArrayValues);
    }
}
